import { User } from 'lucide-react';

export default function Navbar() {
  return (
    <div className="flex-row space-between w-100 ptb-1">
      <div>
        <h1 className="h1-dash">My Dashboard</h1>
        <p>Welcome to your dashboard overview 🎉</p>
      </div>
      <div className="logout flex-row-align gap-1">
        <User className="text-gray-700" />

        <a href="/.auth/logout">Log out</a>
      </div>
    </div>
  );
}
